export const home = {
  hero: {
    label: '/Automatización Inteligente',
    title: 'Automatización e IA para negocios de servicios',
    subtitle: 'Asistentes por WhatsApp, automatizaciones y webs que convierten para clínicas y negocios de servicios. Capta consultas y convierte en citas 24/7, con agenda y calendario sincronizados.',
    guarantee: 'Sin compromiso • Respuesta en 24h'
  },
  benefits: {
    title: 'Resultados que transforman tu negocio',
    items: [
      {
        title: 'Citas más fiables',
        description: 'Recordatorios y confirmaciones automáticas para reducir ausencias.',
        metric: 'Menos ausencias'
      },
      {
        title: 'Más citas confirmadas',
        description: 'Respuesta inmediata que convierte consultas en reservas.',
        metric: 'Más reservas'
      },
      {
        title: 'Ahorro de tiempo',
        description: 'Automatiza tareas repetitivas y libera a recepción.',
        metric: '15h/sem'
      },
      {
        title: 'Atención inmediata',
        description: 'WhatsApp, web y redes: incluso fuera de horario.',
        metric: '24/7'
      },
      {
        title: 'Todo conectado',
        description: 'Agenda, formularios y CRM sincronizados sin duplicar trabajo.',
        metric: 'Todo en 1'
      },
      {
        title: 'Clientes más satisfechos',
        description: 'Seguimiento y respuestas claras que mejoran la percepción del cliente.',
        metric: 'Mejor experiencia'
      }
    ]
  },
  services: {
    title: 'Soluciones completas de automatización',
    subtitle: 'Tecnología para clínicas y negocios de servicios: atención, citas, procesos y captación.',
    items: [
      {
        title: 'Asistente por WhatsApp',
        description: 'Atiende, cualifica y agenda automáticamente en WhatsApp y redes.',
        link: 'Ver detalles'
      },
      {
        title: 'Agenda inteligente',
        description: 'Disponibilidad, confirmaciones y reprogramaciones integradas con tu calendario.',
        link: 'Ver detalles'
      },
      {
        title: 'Webs que convierten',
        description: 'SEO local + formularios + WhatsApp + reservas integradas.',
        link: 'Ver detalles'
      },
      {
        title: 'Recordatorios',
        description: 'Confirmación, recordatorios y seguimiento automático para reducir ausencias.',
        link: 'Ver detalles'
      },
      {
        title: 'Automatización a medida',
        description: 'Diseñamos y conectamos procesos para ahorrar tiempo y vender más.',
        link: 'Ver detalles'
      }
    ],
    integrations: {
      title: 'Integraciones a medida',
      description: 'Conectamos con Google Calendar y las herramientas que ya usas para una sincronización perfecta'
    }
  },
  howItWorks: {
    title: 'Proceso simple en 3 pasos',
    steps: [
      {
        title: 'Análisis',
        description: 'Estudiamos tu negocio y diseñamos la solución perfecta para tus necesidades'
      },
      {
        title: 'Implementación',
        description: 'Configuramos e integramos todas las herramientas en tu flujo de trabajo'
      },
      {
        title: 'Optimización',
        description: 'Monitorizamos resultados y mejoramos continuamente el rendimiento'
      }
    ]
  },
  sectors: {
    title: 'Sectores en los que trabajamos',
    items: [
      'Centros de Estética',
      'Clínicas Dentales',
      'Clínicas Veterinarias',
      'Peluquerías y Salones',
      'Centros de Fisioterapia'
    ]
  },
  faqsShort: {
    title: 'Preguntas frecuentes',
    viewAll: 'Ver todas las FAQs',
    items: [
      {
        question: '¿Cuánto tiempo tarda la implementación?',
        answer: 'Dependiendo de la complejidad, entre 1 y 3 semanas. Comenzarás a ver resultados desde el primer día de activación.'
      },
      {
        question: '¿Se integra con mi sistema actual?',
        answer: 'Sí, nos integramos con Google Calendar y la mayoría de herramientas de gestión. Si usas un sistema específico, lo evaluamos en la consulta inicial.'
      },
      {
        question: '¿Funciona en WhatsApp y redes sociales?',
        answer: 'Absolutamente. Nuestro chatbot funciona en WhatsApp, Instagram, Facebook Messenger y tu página web de forma unificada.'
      },
      {
        question: '¿Necesito conocimientos técnicos?',
        answer: 'No. Nos encargamos de toda la configuración y te enseñamos a usar el sistema de forma sencilla. El soporte está siempre disponible.'
      },
      {
        question: '¿Qué incluye el soporte?',
        answer: 'Soporte técnico continuo, actualizaciones automáticas, ajustes según tus necesidades y formación para tu equipo.'
      }
    ]
  },
  ctaFinal: {
    title: '¿Listo para automatizar tu negocio?',
    subtitle: 'Agenda una consulta gratuita y descubre cómo captar, atender y gestionar clientes con IA.',
    guarantee: 'Sin compromiso • Respuesta en 24h'
  }
};
